import { createActionConst } from '../../../utils/action.utils';

const SUBSCRIPTION_PAGE_NAMESPACE = 'SUBSCRIPTION_PAGE';

export const INITIAL_SUBSCRIPTION_PAGE = createActionConst(SUBSCRIPTION_PAGE_NAMESPACE, 'INITIAL_SUBSCRIPTION_PAGE');

export const CREATE_SETUP_INTENT = createActionConst(SUBSCRIPTION_PAGE_NAMESPACE, 'CREATE_SETUP_INTENT');
export const STORE_SETUP_SESSION = createActionConst(SUBSCRIPTION_PAGE_NAMESPACE, 'STORE_SETUP_SESSION');
export const CLEAR_SETUP_SESSION = createActionConst(SUBSCRIPTION_PAGE_NAMESPACE, 'CLEAR_SETUP_SESSION');

export const ADD_PAYMENT_METHOD = createActionConst(SUBSCRIPTION_PAGE_NAMESPACE, 'ADD_PAYMENT_METHOD');
export const SET_DEFAULT_PAYMENT_METHOD = createActionConst(SUBSCRIPTION_PAGE_NAMESPACE, 'SET_DEFAULT_PAYMENT_METHOD');
export const DELETE_PAYMENT_METHOD = createActionConst(SUBSCRIPTION_PAGE_NAMESPACE, 'DELETE_PAYMENT_METHOD');

export const START_BILLING = createActionConst(SUBSCRIPTION_PAGE_NAMESPACE, 'START_BILLING');
export const CANCEL_SUBSCRIPTION = createActionConst(SUBSCRIPTION_PAGE_NAMESPACE, 'CANCEL_SUBSCRIPTION');
export const REACTIVATE_SUBSCRIPTION = createActionConst(SUBSCRIPTION_PAGE_NAMESPACE, 'REACTIVATE_SUBSCRIPTION');

export const STORE_BILLING_INFO = createActionConst(SUBSCRIPTION_PAGE_NAMESPACE, 'STORE_BILLING_INFO');
export const CLEAR_BILLING_INFO = createActionConst(SUBSCRIPTION_PAGE_NAMESPACE, 'CLEAR_BILLING_INFO');
export const SAVE_BILLING_INFO = createActionConst(SUBSCRIPTION_PAGE_NAMESPACE, 'SAVE_BILLING_INFO');
